import { render, staticRenderFns } from "./CanvasLogo.vue?vue&type=template&id=9fa4707e&scoped=true&"
import script from "./CanvasLogo.vue?vue&type=script&lang=js&"
export * from "./CanvasLogo.vue?vue&type=script&lang=js&"
import style0 from "./CanvasLogo.vue?vue&type=style&index=0&id=9fa4707e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa4707e",
  null
  
)

export default component.exports